import { GENRE_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { GenreInterface } from 'type/genreType';

class GenreApiService extends ApiService<GenreInterface> {
  constructor() {
    super(GENRE_API_PATH);
  }
}

export const genreApiService = new GenreApiService();
